// extracted by mini-css-extract-plugin
module.exports = {"panel":"AppPanel__panel___qsZbz","triangle":"AppPanel__triangle___1zlpb","mainPanel":"AppPanel__mainPanel___3bS0v"};